'use client';

import { faArrowDown, faArrowUp } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { InstallmentTerms } from '@/components/ui/installment-terms.component';

interface SearchCardScheduleToggleProps {
  totalPrice: number;
  isOpen: boolean;
  controlsId: string;
  onToggle: () => void;
}

export const SearchCardScheduleToggle = ({
  totalPrice,
  isOpen,
  controlsId,
  onToggle,
}: SearchCardScheduleToggleProps) => (
  <div className="flex items-center gap-2">
    <InstallmentTerms
      totalPrice={totalPrice}
      stacked
      className="text-center leading-tight"
      containerClassName="flex-1 w-auto justify-center"
    />
    <Button
      variant={isOpen ? 'secondary' : 'default'}
      color="primary"
      endIcon={isOpen ? faArrowUp : faArrowDown}
      className="flex-1"
      aria-expanded={isOpen}
      aria-controls={controlsId}
      data-testid={DataTestIdEnum.SEARCH_CARD_SCHEDULE_TOGGLE}
      onClick={onToggle}
    >
      {isOpen ? 'Fechar' : 'Ver horários'}
    </Button>
  </div>
);
